import { render, staticRenderFns } from "./PageComingSoon.vue?vue&type=template&id=39b9d00c"
import script from "./PageComingSoon.vue?vue&type=script&lang=js"
export * from "./PageComingSoon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports